import React from 'react';
import './index.scss';

import { Redirect, Link } from "react-router-dom";
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {User, UserTypes} from '../../store/ducks/user/types';
import * as UserActions from '../../store/ducks/user/actions';
import {Param, ParamTypes} from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import {Cart, CartTypes, ProductType} from '../../store/ducks/cart/types';
import * as CartActions from '../../store/ducks/cart/actions';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Api from '../../services/api';
import {Diversos} from '../../services/diversos';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

import Image from 'react-bootstrap/Image'

import Prod1 from '../../assets/Images/image-3.png'
import Prod2 from '../../assets/Images/image-2.png'
import Prod3 from '../../assets/Images/image-3.png'

interface StateProps { 
  user: User;
  param: Param;
  cart: Cart;
} 

interface DispatchProps {
  doLogin(user: User): void;
  setParam(param: Param): void;
  drop(rowid: string): void;
}

interface OwnProps {
  item: any;
}

type Props = StateProps & DispatchProps & OwnProps;

class Checkout extends React.Component<Props> {

  api: any = null;
  state: any = null;

  constructor(props) {
    super(props);
    this.api = new Api();
    this.state = {
      redirect: null,
      isLoading: false,
      email: "",
      senha: "",
      hasError: false,
      hasErrorTitle: "",
      hasErrorMsg: "",
      quantity: 1
    }
  }

  componentDidMount () {
    const self = this; 
    // if (( self.props.user ) && ( self.props.user.status === true )) { // SE USUARIO ESTIVER LOGADO REDIRECIONA PARA OUTRA PAGINA
    //   self.setState({redirect: '/'});
    // }
  }

  handleChange = (event) => {
    this.setState({quantity: event.target.value});
  }

    // Funções repetidas do Produto. Melhorar
    // Funções não estao funcionando. Ver "state" e "row.qty"
    private IncreaseItem = () => {
      this.setState(prevState => {
        if (this.state.quantity < 9999) {
          return {
            quantity: this.state.quantity + 1
          }
        }
  
        else {
          return null;
        }
      });
    }
  
    private DecreaseItem = () => {
      this.setState(prevState => {
        if (this.state.quantity > 0) {
          return {
            quantity: this.state.quantity - 1
          }
        }
  
        else {
          return null;
        }
      });
    }

  private getCartTotal () {
    const self = this;
    let total = 0.00;
    for ( var i = 0; i < self.props.cart.produtos.length; i++ ) {
      total += self.props.cart.produtos[i].price * self.props.cart.produtos[i].qty;
    }
    return total;
  }

  private handleDropProduto (item: any) {
    const self = this;

    if ( !item )
      return;

    let confirmDrop = window.confirm(`Deseja realmente excluir o produto ${item.nome} do seu carrinho?`);

    if ( confirmDrop )
      self.props.drop(item.rowid);
  }

  render () {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    return (
      <>
        <Header tipo={2}/>

        <section className="content-fluid checkout-container">
          <span className="mt-2 mb-5 checkout-title">
            <h1> Checkout </h1>
            <h2> <FontAwesomeIcon icon={faShoppingCart}/> Itens do carrinho </h2>
          </span>
          {
            (this.props.cart.produtos.length <= 0) ? 
            <>
              <Row> 
                <Col>
                  <div className="alert custom-alert"> Seu carrinho está vazio. Navegue por nossa loja e encontre seus produtos favoritos! </div>
                </Col>
              </Row>

              <Row className="my-3">
                <Col>
                  <a href="/" target="_self" className="btn btn-link checkout-keep-shopping">
                    <FontAwesomeIcon icon={faArrowLeft} className="mr-2 text-link" /> 
                    Continuar comprando
                  </a>
                </Col>
              </Row>
            </>
            :
            <>
            {
              this.props.cart.produtos.map((row, index) => (
                <article className="compra-container" key={index}>
                  <div className="compra-img-container">
                    <Image
                    // src={Prod1}
                    src={`${process.env.REACT_APP_BASE_URL_PICTURE}/${Diversos.toSeoUrl(row.nome)}-1.png`}
                    className="compra-img"/>
                  </div>
                  <div className="compra-detalhes-container">
                    <span className="compra-detalhes">
                      <h5> {row.nome} </h5>
                      <p> R$ {Diversos.number_format((row.price * row.qty),2,",","")} </p>
                    </span>
                    <span className="compra-qtde">
                      <button className="cart-amount-btn" onClick={this.DecreaseItem}> - </button>
                      <input type="number"
                      className="cart-amount-input"
                      name="quantidade"
                      value={row.qty || ""}
                      onChange={this.handleChange}
                      min="1"
                      max="9999"
                      step="1"
                      defaultValue="1" />
                      <button className="cart-amount-btn" onClick={this.IncreaseItem}> + </button>
                    </span>
                  </div>
                  <div className="compra-actions">
                    <span>
                      <h5> SUBTOTAL </h5>
                      <p> {Diversos.number_format((row.price * row.qty),2,",","")} </p>
                    </span>
                    <Button variant="link">
                      <FontAwesomeIcon icon={faTrashAlt} className="cart-item-action color-modifier" title="Excluir item" onClick={this.handleDropProduto.bind(this, row)}/> 
                    </Button>
                  </div>
                </article>
              ))
            }
            </>
          }
        </section>

        {

        (this.props.cart.produtos.length > 0) ? 

          <div className="checkout-continue-container">
            <span className="checkout-continuar">
              <a href="/" target="_self" className="btn btn-link-action">
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2 text-link" /> 
                Continuar comprando
              </a>
            </span>
            <span className="checkout-subtotal">
              <h2> SUBTOTAL </h2>
              <p> R$ {Diversos.number_format(this.getCartTotal(),2,",","")} </p>
            </span>
            <span className="checkout-finalizar">
              <a href={(( this.props.user ) && ( this.props.user.status === true )) ? `/checkout/entrega` : `/login`} className="btn-primary-action btn-checkout">
                <FontAwesomeIcon icon={faShoppingCart} className="mr-2 text-white" /> 
                Finalizar compra
              </a>
            </span>
          </div>
        :
          null
          
        }
        
        <Footer/>
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data,
  cart: state.cart.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...UserActions, ...ParamActions, ...CartActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Checkout);
